import { Injectable } from "@angular/core";
import { AlertMessage, AlertMessageType } from "./alert-message";
import { PopupMessage } from "./popup-message";
import { ActionService } from "src/app/services/action.service";
import { NotificationSoundService } from "./notification-sound.service";
import { Subscription } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/internal/operators/filter";

@Injectable({
  providedIn: "root",
})
export class MessageService {
  static onErrorSubscription: Subscription;
  constructor(
    action: ActionService,
    private notificationSound: NotificationSoundService,
    router: Router,
  ) {
    if (MessageService.onErrorSubscription) {
      MessageService.onErrorSubscription.unsubscribe();
    }
    MessageService.onErrorSubscription = action.onError().subscribe((msg) => {
      this.sendAlert(msg, true);
    });

    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.popupMessages = [];
      });
  }

  public static alertMessages: AlertMessage[] = [];

  public sendAlert(message: string, isError?: boolean) {
    this.sendActionAlert(message, undefined, isError);
  }
  public sendActionAlert(
    message: string,
    href: string | undefined,
    isError?: boolean,
  ) {
    const alert = new AlertMessage(
      message,
      isError ? AlertMessageType.WARNING : AlertMessageType.INFO,
      href,
    );
    MessageService.alertMessages.push(alert);
    setTimeout(() => {
      const index = MessageService.alertMessages.indexOf(alert);
      if (index >= 0) MessageService.alertMessages.splice(index, 1);
    }, 10000);
  }

  public popupMessages: PopupMessage[] = [];

  public sendPopup(message: PopupMessage, alertTone = false) {
    console.log(message);
    (document.activeElement as any)?.blur();
    this.popupMessages.push(message);
    if (alertTone) {
      this.notificationSound.play();
    }
  }

  public mute() {
    this.notificationSound.mute();
  }
  public get muted() {
    return this.notificationSound.muted;
  }
}
